var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('picture', [_c('source', {
    attrs: {
      "type": "image/webp",
      "media": "(max-width:540px)",
      "srcset": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "backgroundImage",
    attrs: {
      "loading": "eager",
      "src": _vm.urlFor(_vm.image.asset).auto('format').url()
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };